import React, { FC, useContext } from 'react';

import { Select, Tooltip } from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from '../../../TinkoffModal.module.scss';
import { IFormBlockProps } from '../interfaces';
import { serviceNameOptions, taxOption } from './constants';

export const Service: FC<IFormBlockProps> = ({ control }) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.form__block}>
      <div className={s.form__block__header}>
        <span className={s.title}>Вид услуги</span>
        <Tooltip
          content="Название оказанной услуги в чеке за пополнение депозита"
          position="bottom-left"
          contentClassName={s.tooltip}
        />
      </div>
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Select
            {...field}
            title="Название услуги в чеке"
            error={error?.message}
            options={serviceNameOptions}
          />
        )}
        control={control}
        name="service_name"
        rules={{
          required: t('errors.required'),
        }}
      />

      <Controller
        render={({ field, fieldState: { error } }) => (
          <Select
            {...field}
            options={taxOption}
            error={error?.message}
            title="Тип налога"
          />
        )}
        name="tax"
        control={control}
        rules={{
          required: t('errors.required'),
        }}
      />
    </div>
  );
};
